import { atom } from "jotai";

export const listCenterAtom = atom<any[] | []>([]);
